import React from 'react'
import { Redirect } from 'react-router-dom'
import BasicLayout from '../components/layout/BasicLayout'
import routerConstants from '../constants/routerConstants'

const ToChiNhanhTab = () => React.createElement(Redirect, { to: `${routerConstants.duAn.list}?tab=chi-nhanh` })

const routeChiNhanh: any[] = [
  { path: routerConstants.chiNhanh.list, name: 'chiNhanhList', exact: true, layout: BasicLayout, component: ToChiNhanhTab, },
  { path: routerConstants.chiNhanh.add, name: 'chiNhanhAdd', exact: true, layout: BasicLayout, component: ToChiNhanhTab, },
  { path: routerConstants.chiNhanh.edit, name: 'chiNhanhEdit', exact: false, layout: BasicLayout, component: ToChiNhanhTab, },
]
export { routeChiNhanh }
